export enum OperatingMode {
  STANDBY = "STANDBY",
  AUTO = "AUTO",
  MANUAL = "MANUAL",
  SEMI_AUTO = "SEMI_AUTO",
}

export enum OperatingState {
  GROUND_IDLE = "GROUND_IDLE",
  TAKEOFF = "TAKEOFF",
  CRUISE = "CRUISE",
  LANDING = "LANDING",
  HOVER = "HOVER",
  EMERGENCY = "EMERGENCY",
}

export enum AlertLevel {
  INFO = "INFO",
  WARN = "WARN",
  CRITICAL = "CRITICAL",
}
